export default __webpack_public_path__ + "static/media/Maze.78db3f15.png";